import { render, staticRenderFns } from "./VlTypeOfExaminationFilter.vue?vue&type=template&id=e12b7ec6&scoped=true&"
import script from "./VlTypeOfExaminationFilter.vue?vue&type=script&lang=js&"
export * from "./VlTypeOfExaminationFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12b7ec6",
  null
  
)

export default component.exports